<style scoped>
.logo-kemendagri {
  padding-left: 1rem;
  height: 65px;
}
.logo-sp {
  height: 50px;
}
.logo-bps {
  width: 80px;
}
.logo-garuda {
  width: 80px;
}
.table-contoh > tr > td {
  text-align: center;
}
</style>
<template>
  <b-container class="content landing-page">
    <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
    <b-container>
      <title-page
        :title="'Unduh Kuesioner Ground Chek'"
        :subtitle="'Lakukan penginputan data berdasarkan isian hasil ground check anomali.'"
      />
      <b-alert show variant="primary" v-if="isLoadingGenerate"
        >Sedang melakukan generate berkas kuesioner, mohon tunggu !</b-alert
      >
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="warning"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
      >
        <p>Sedang mengunduh berkas kuesioner, mohon tunggu !</p>
        <b-progress
          variant="warning"
          :max="dismissSecs"
          :value="dismissCountDown"
          height="4px"
        ></b-progress>
      </b-alert>
      <div v-if="!isLoadingDownload && !isLoadingGenerate">
        <b-alert show variant="success"
          >Berkas kuesioner sudah tersedia, klik tombol unduh untuk mengunduh
          !</b-alert
        >
        <b-button variant="success" @click="download()">Download</b-button>
      </div>
    </b-container>
  </b-container>
</template>
<script>
import titlePage from "@/components/Title";
import kuesionerService from "../../../services/sdpi/KuesionerService";
export default {
  components: { titlePage },
  data: () => {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sdpi",
        },
        {
          text: "Konfirmasi",
          to: "/sdpi/konfirmasi",
        },
        {
          text: "Kuesioner",
          active: true,
        }
      ],
      isLoadingGenerate: true,
      isLoadingDownload: false,
      dismissSecs: 10,
      dismissCountDown: 0
    };
  },
  methods: {
    async getDownload(nomor_kk) {
      await kuesionerService.download(nomor_kk).then(
        (response) => {
          this.isLoadingDownload = false;
          let blob = new Blob([response.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = nomor_kk + ".pdf";
          link.click();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async generate(kode_sls, nomor_kk) {
      await kuesionerService.generate(kode_sls, nomor_kk).then(
        (response) => {
          this.isLoadingGenerate = false;
          console.log(response.data);
        },

        (error) => {
          console.log(error);
        }
      );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    download() {
      this.dismissCountDown = this.dismissSecs;
      this.isLoadingDownload = true;
      this.getDownload(this.$route.params.nomor_kk);
    },
  },
  mounted() {
    this.generate(this.$route.params.kode_sls, this.$route.params.nomor_kk);
  },
  watch: {},
};
</script>
